import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { AdditionalInfoObject, ConfigurationApi, ExitRequestActivity, LookupApi, LookupField } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';
import { nullSafe } from 'src/app/utils';

@Component({
  selector: 'eos-exit-task-amend-edit',
  templateUrl: './exit-task-amend-edit.component.html',
  styleUrls: ['./exit-task-amend-edit.component.css']
})
export class ExitTaskAmendEditComponent implements OnInit {

  activity: ExitRequestActivity;
  exitTypes: LookupField[];
  exitSubTypes: LookupField[] = [];
  nationalityType: LookupField[];
  officeLocation: LookupField[] = [];
  rank: LookupField[] = [];
  isEdit: boolean;
  get isEditMode(): boolean {
    return (this.activity !== undefined && this.isEdit);
  }





  activityTypes = [
    {
      id: 100,
      displayText: 'Email',
      disabled: false
    },
    {
      id: 101,
      displayText: 'Profile update',
    },
    {
      id: 102,
      displayText: 'External',
      disabled: false
    },
    {
      id: 103,
      displayText: 'Request',
      disabled: false
    }
  ];



  createForm = new UntypedFormGroup({
    activityType: new UntypedFormControl(null, [Validators.required]),
    order: new UntypedFormControl(null, [Validators.required]),
    header: new UntypedFormControl(null, [Validators.required]),
    description: new UntypedFormControl(null, [Validators.required]),
    isActive: new UntypedFormControl(true, [Validators.required]),
    exitType: new UntypedFormControl(null, [Validators.required]),
    nationalityType: new UntypedFormControl(null),
    officeLocation: new UntypedFormControl(null),
    rank: new UntypedFormControl(null),
    exitSubType: new UntypedFormControl(null),
    isPartner: new UntypedFormControl(false),
    id: new UntypedFormControl(0)
  });
  activityId: number;
  exitSubTypeInfo = [];





  constructor(
    private configurationService: ConfigurationApi,
    private loader: LoaderService,
    public modal: NgbActiveModal,
    private toast: ToastService,
    private common: CommonService,
    private lookupApi: LookupApi,
  ) {
  }

  ngOnInit() {
    if (this.isEditMode) {
      //console.log(this.activity.id)
      this.bindActivityInfo(this.activity)
    }
    this.exitSubTypeInfo = this.exitSubTypes;
    this.exitTypeValueChange();
  }

  createActivity() {

    const rawValues = this.createForm.getRawValue();
    const exitActivities = this.getFormData(rawValues);

    if (exitActivities.isActive && exitActivities.order <= 0) {
      this.toast.warning("Order should be greater than zero for an active activity")
    }
    else if (!exitActivities.isActive && exitActivities.order != 0) {
      this.toast.warning("To modify the order of an activity, please set the activity to 'Active'")
    }
    else {
      this.loader.show();
      this.configurationService.saveExitActivities(exitActivities)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(resp => {
          if (resp.statusCode == 400) {
            this.toast.warning('Activity with same order already exist');
          }
          else {
            if (this.isEditMode) {
              this.toast.success('Successfully updated activity')
            } else {
              this.toast.success('Successfully created activity')
            }
            this.modal.close('success');
          }
        }, err => this.toast.error('Error occured please try again!')
        );
    }
  }


  bindActivityInfo(r: ExitRequestActivity) {
    this.createForm.patchValue({
      isActive: r.isActive,
      activityType: r.activityType,
      order: r.order,
      header: r.header,
      description: r.description,
      exitType: r.exitTypeId,
      id: r.id
    });
    if (r.additionalInfoObj) {
      this.createForm.patchValue({
        exitSubType: r.additionalInfoObj.exitSubTypes,
        nationalityType: r.additionalInfoObj.nationalityType,
        officeLocation: r.additionalInfoObj.officeLocation,
        isPartner: r.additionalInfoObj.isPartner === 1 ? true : false,
        rank: r.additionalInfoObj.rank
      });
    }
  }





  getFormData(rawValues) {
    const internalAct = new ExitRequestActivity(
      {
        activityType: rawValues.activityType,
        order: rawValues.order,
        header: rawValues.header,
        description: rawValues.description,
        exitTypeId: rawValues.exitType,
        id: rawValues.id,
        isActive: rawValues.isActive,
        additionalInfoObj: this.checkIfAdditionalInfoNull(rawValues)
      });
    return internalAct;
  }







  onExitChange($event) {
    this.exitTypeValueChange();
    this.resetValue();
  }

  exitTypeValueChange() {
    const a = this.createForm.controls.exitType.value;
    if (a != null && a !== undefined) {
      this.exitSubTypeInfo = this.exitSubTypes.filter(i => [a].includes(i.parentFieldId));
    }
  }


  resetValue() {
    this.createForm.get('exitSubType').reset();
  }

  onCancel() {
    this.modal.dismiss();
  }


  checkIfAdditionalInfoNull(rawValues) {
    const obj = new AdditionalInfoObject({
      exitSubTypes: rawValues.exitSubType,
      officeLocation: rawValues.officeLocation,
      nationalityType: rawValues.nationalityType,
      isPartner: rawValues.isPartner === true ? 1 : null,
      rank: rawValues.rank,
    });
    Object.keys(obj).forEach(key => {
      if (obj[key] === null || obj[key] === undefined || nullSafe(() => obj[key].length === 0)) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every(x => (x === null));
  }
}
